import createStyledEnhancer from "../helpers/createStyledEnhancer";
import { composeEnhancers } from "../helpers";

var flexBoxTransformation = function flexBoxTransformation(property) {
  if (property) {
    return {
      display: "flex"
    };
  }

  return {};
};

export var flexboxProperty = createStyledEnhancer({
  name: "flexbox",
  directTransformation: true,
  transformation: flexBoxTransformation
});
export var flex = createStyledEnhancer({
  name: "flex",
  addPx: false
});
export var flexGrow = createStyledEnhancer({
  name: "flexGrow",
  addPx: false
});
export var flexShrink = createStyledEnhancer({
  name: "flexShrink",
  addPx: false
});
export var flexBasis = createStyledEnhancer({
  name: "flexBasis"
});
export var flexDirection = createStyledEnhancer({
  name: "flexDirection"
});
export var flexWrap = createStyledEnhancer({
  name: "flexWrap"
});
export var flexFlow = createStyledEnhancer({
  name: "flexFlow"
});
export var alignItems = createStyledEnhancer({
  name: "alignItems"
});
export var justifyContent = createStyledEnhancer({
  name: "justifyContent"
});
export var alignSelf = createStyledEnhancer({
  name: "alignSelf"
});
export var alignContent = createStyledEnhancer({
  name: "alignContent"
});
export var order = createStyledEnhancer({
  name: "order",
  addPx: false
});
export var flexbox = composeEnhancers(flexboxProperty, flex, flexGrow, flexShrink, flexBasis, flexDirection, flexWrap, flexFlow, alignItems, justifyContent, alignSelf, alignContent, order);
export var flexItem = composeEnhancers(flex, flexGrow, flexShrink, flexBasis, alignSelf, order);
/** Пропсы, которые стайлед будет пытаться преобразовать в атрибуты. Нужны для фильтрации */

export var flexboxPropsNoForward = ["order"];